import React from "react";

// Shared step header for every "cadastro" (registration) wizard — Numbering
// wizard with label style (form-wizard-list, numbered circle + text label per
// step), reused so every create screen looks and behaves the same way instead
// of a single flat card.
const WizardSteps = ({ steps, currentStep }) => (
  <div className='form-wizard-header overflow-x-auto scroll-sm pb-8 my-32'>
    <ul className='list-unstyled form-wizard-list'>
      {steps.map((label, idx) => {
        const stepNumber = idx + 1;
        return (
          <li
            key={label}
            className={`form-wizard-list__item ${currentStep > stepNumber ? "activated" : ""} ${
              currentStep === stepNumber ? "active" : ""
            }`}
          >
            <div className='form-wizard-list__line'>
              <span className='count'>{stepNumber}</span>
            </div>
            <span className='text text-xs fw-semibold'>{label}</span>
          </li>
        );
      })}
    </ul>
  </div>
);

export default WizardSteps;
